import { createFileRoute } from '@tanstack/react-router'
import { LendMarketPage } from '@/features/lend/market/LendMarketPage'

export const Route = createFileRoute('/_app/lend/market')({
  component: LendMarketPage,
})
